module.exports = __webpack_public_path__ + "media/images/parceiros_pagamentos/elo-logo-d7b76ba348b6010cbaf2e96d3dbf5973.svg";